import zhTW from '@/internationalization/trans/chefs/zhTW/zh-TW.json';
export default {
  trans: zhTW,
};
